import { render, staticRenderFns } from "./SearchTwo.vue?vue&type=template&id=2b12c778&scoped=true"
import script from "./SearchTwo.vue?vue&type=script&lang=js"
export * from "./SearchTwo.vue?vue&type=script&lang=js"
import style0 from "./SearchTwo.vue?vue&type=style&index=0&id=2b12c778&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12c778",
  null
  
)

export default component.exports